import React, {Fragment} from 'react';
import PropTypes from "prop-types";

const Text = (props) => {
    return (
        <Fragment>
            {props.condition ?
                <span><mark>{props.text}</mark></span>
                :
                <span>{props.text}</span>
            }
        </Fragment>
    );
};

export default Text;

Text.defaultProps = {
    text: '',
    condition: false,
};

Text.propTypes = {
    text: PropTypes.string,
    condition: PropTypes.bool,
};


// WEBPACK FOOTER //
// ./sources/js/components/Summary/SummaryQuestionText.js